import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const STATIC_TITLES = {
  '/ask-us':        'Ask Us',
  '/feedback':      'Feedback',
  '/contact':       'Contact Us',
  '/support':       'Support Us',
  '/admin/queries': 'Admin — Manage Queries',
};

// Matches the gradients in CategoryBanner BANNER_CONFIG
const CATEGORY_GRADIENTS = {
  technology:    'from-indigo-600 via-indigo-700 to-purple-800',
  science:       'from-purple-600 via-violet-700 to-indigo-900',
  finance:       'from-emerald-600 via-teal-600 to-cyan-800',
  india_finance: 'from-slate-500 via-slate-600 to-slate-800',
  health:        'from-teal-500 via-cyan-600 to-teal-700',
  education:     'from-blue-600 via-blue-700 to-indigo-800',
  space:         'from-violet-800 via-purple-900 to-slate-900',
  sports:        'from-orange-500 via-amber-600 to-orange-700',
  fashion:       'from-pink-500 via-rose-600 to-fuchsia-700',
};

function UserIcon() {
  return (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  );
}

export default function Navbar({ onMenuClick }) {
  const { pathname } = useLocation();
  const { user }     = useAuth();

  const staticTitle = STATIC_TITLES[pathname];
  const isCategory  = /^\/dashboard\/([a-z_]+)$/.test(pathname);

  if (isCategory) return (
    <header className="lg:hidden bg-slate-900 px-4 py-3 flex items-center justify-between shrink-0">
      <button onClick={onMenuClick} className="text-white p-1" aria-label="Open menu">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      <span className="text-white font-bold text-sm">TERAINFO</span>
      <div className="w-8" />
    </header>
  );

  return (
    <header className="bg-white border-b border-gray-200 px-4 sm:px-6 py-3.5 flex items-center justify-between shrink-0 shadow-sm animate-fade-in">
      <div className="flex items-center gap-3">
        <button onClick={onMenuClick} className="lg:hidden text-gray-500 hover:text-gray-700 p-1" aria-label="Open menu">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <h2 className="text-base font-semibold text-gray-800 animate-slide-in-left">
          {staticTitle ?? 'TERAINFO'}
        </h2>
      </div>

      <div className="flex items-center gap-2.5 text-sm text-gray-600">
        {user ? (
          <>
            <div className="w-7 h-7 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center shrink-0">
              <UserIcon />
            </div>
            <span className="text-gray-400">Hello,</span>
            <span className="font-semibold text-gray-800">{user?.name}</span>
            {user?.role === 'admin' && (
              <span className="px-2 py-0.5 bg-indigo-100 text-indigo-700 text-xs font-semibold rounded-full">
                Admin
              </span>
            )}
          </>
        ) : (
          <>
            <Link to="/login" className="px-3 py-1.5 text-indigo-600 font-semibold hover:text-indigo-800 transition-colors">
              Login
            </Link>
            <Link to="/register" className="px-3 py-1.5 bg-indigo-600 text-white font-semibold rounded-lg hover:bg-indigo-700 transition-colors">
              Sign Up
            </Link>
          </>
        )}
      </div>
    </header>
  );
}
